import React from 'react'
import { Link } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'

import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'

import ExtensionIcon from '@material-ui/icons/Extension'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { getBreakpointsEnable, makePath } from '../../../lib'
import { WID } from '../../../constants/Language';
import Word from '../../../containers/Common/Word';
import { useContext } from 'react'
import { SettingsContext } from '../../../Parts/Settings'

const styles1 = {
}

const PuzzleMenuItems = withStyles(styles1, { withTheme: true })((props) => {
  const { classes, user, divider } = props

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const handleClick = (name) => (event) => {
    if (props.onClose) {
      props.onClose()
    }
  }

  return (
    <React.Fragment>
      <MenuItem component={Link} to={makePath('/puzzle', language)} onClick={handleClick('home')}>
        <ListItemIcon className={classes.icon}>
          <ExtensionIcon/>
        </ListItemIcon>
        <ListItemText inset primary={<Word wid={WID.PUZZLE_MENU.HOME}/>} />
      </MenuItem>
      {divider && (<Divider/>)}
      {user && (
        <MenuItem component={Link} to={makePath('/puzzle/register', language)} onClick={handleClick('register')}>
          <ListItemIcon className={classes.icon}>
            <AddCircleIcon/>
          </ListItemIcon>
          <ListItemText inset primary={<Word wid={WID.PUZZLE_MENU.REGISTER}/>} />
        </MenuItem>
      )}
    </React.Fragment>
  )
})

const styles2 = {
}

class PuzzleMenu extends React.Component {
  state = {
    anchorEl: null,
  }

  handleOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const { theme, user, width } = this.props
    const { anchorEl } = this.state
    const { md } = getBreakpointsEnable(theme, width)
    if (md === false) {
      return (
        <div>
          <IconButton onClick={this.handleOpen} color='inherit'>
            <MoreVertIcon/>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <PuzzleMenuItems user={user} onClose={this.handleClose}/>
          </Menu>
        </div>
      )
    }
    else {
      return (<div></div>)
    }
  }
}

PuzzleMenu = withStyles(styles2, { withTheme: true })(PuzzleMenu)

export { PuzzleMenuItems, PuzzleMenu }


// WEBPACK FOOTER //
// ./src/Pages/Puzzle/components/PuzzleMenu.js